module.exports = __webpack_public_path__ + "img/form-tri1.080816ca.svg";